module.exports = __webpack_public_path__ + "static/media/loader-gray.abbf3a27.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/loader-gray.gif
// module id = 169
// module chunks = 0